<template>
  <div class="sn-page sn-assembly tip-caption" v-if="exhibition">
    <sn-popup :title="format.guideTitle" :cancel="false" @sendBack="sendBack">
      <div class="sn-f-col-b-c region">
        <div class="sn-f-1 tip-info" @scroll.passive="handleScroll">
          <div v-if="['0', '1'].includes(format.showType)" v-html="format.guideContent"></div>
          <template v-else>
            <div class="sn-f-c-c tip-blank" :key="i" v-for="(item, i) in format.guideContent">
              <!-- 0：标题，1：文本（换行） -->
              <template v-if="['0', '1'].includes(item.type)">
                <div v-if="!$sn.validate.html(item.info)" :class="item.style">{{item.info}}</div>
                <div v-else :class="item.style" v-html="item.info"></div>
              </template>
              <!-- 2：图片（单个） -->
              <template v-else-if="item.type === '2'">
                <div :class="item.style">
                  <img :style="{
                    '--width': item.width,
                    '--height': item.height || item.width
                  }" :src="item.info">
                </div>
              </template>
              <!-- 3：图片（多个居中） -->
              <template v-else-if="item.type === '3'">
                <div class="sn-f-c-c" :class="item.style" :key="j" v-for="(element, j) in item.info">
                  <img :style="{
                    '--width': item.width,
                    '--height': item.height || item.width
                  }" :src="element">
                </div>
              </template>
              <!-- 4：图片（单一图片横向滑动） -->
              <div :class="item.style" v-else-if="item.type === '4'">
                <img :style="{
                    '--height': item.height
                  }" :src="item.info">
              </div>
            </div>
          </template>
        </div>
        <div class="sn-f-e-c tip-bottom">
          <div class="sn-f-c-c sn-pointer tip-interaction" :class="{'sn-silence': rotation !== 0}" @click="sendBack(true);">
            {{rotation === -1 ? slideCaption : format.buttonContent}}
            <template v-if="rotation > 0">{{'（' + rotation +  's）'}}</template>
          </div>
        </div>
      </div>
    </sn-popup>
  </div>
</template>
<script type="text/javascript">
import { gatherConfig } from '@/common/utils/function-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  name: 'sn-tip-caption',
  mixins: [HomepageMixin],
  props: {
    // 0：直接富文本展示；1：使用须知配置；2：使用 OSS 文件
    mode: {
      type: String,
      default: '1'
    },
    // 标题
    title: {
      type: String,
      default: '温馨提示'
    },
    // 文件库域名
    domain: {
      type: String,
      default: 'static'
    },
    // 文件库路由
    url: {
      type: String,
      default: ''
    },
    /*
    当 mode 为0时，传递富文本内容
    当 mode 为1时，传递须知类型
     */
    secretary: {
      type: String,
      default: ''
    },
    // 按钮文案
    interaction: {
      type: String,
      default: '我知道了'
    },
    // 倒计时：无-0，有-单位s，滚动到底部- -1
    duration: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      format: {},
      htmlCaption: [],
      rotation: 0,
      rotationInterval: null,
      exhibition: false
    };
  },
  computed: {
    slideCaption() {
      const initial = '请滑动至底部完成预览';
      if (this.$sn.validate.empty(this.format)) return initial;
      else {
        if (this.format.buttonExt && this.$sn.validate.json(this.format.buttonExt) && JSON.parse(this.format.buttonExt).beforeButtonContent) {
          return JSON.parse(this.format.buttonExt).beforeButtonContent;
        }
        else return initial;
      }
    }
  },
  created: function() {
    this.initialInformation();
  },
  methods: {
    async initialInformation() {
      this.exhibition = false;
      this.$sn.assembly.loading(true);
      const verify = await this.handleInformation();
      this.$sn.assembly.loading(false);
      if (verify) {
        if (['0', '2'].includes(this.mode)) {
          this.$set(this.format, 'guideTitle', this.title);
          this.$set(this.format, 'guideContent', this.mode === '0' ? this.secretary : this.htmlCaption);
          this.$set(this.format, 'showType', this.mode === '0' ? this.mode : '-1');
          this.$set(this.format, 'buttonContent', this.interaction);
          if (this.duration === 0) {
            this.$set(this.format, 'buttonType', '0');
            this.$set(this.format, 'buttonExt', JSON.stringify({}));
          }
          else if (this.duration > 0) {
            this.$set(this.format, 'buttonType', '1');
            this.$set(this.format, 'buttonExt', JSON.stringify({
              buttonSecond: this.duration
            }));
          }
          else {
            this.$set(this.format, 'buttonType', '2');
            this.$set(this.format, 'buttonExt', JSON.stringify({
              beforeButtonContent: '请滑动至底部完成预览'
            }));
          }
        }
        // 站内功能、外部 H5、外部小程序
        if (['1', '2', '3'].includes(this.format.showType)) {
          let url = '';
          let item = {};
          let params = {};
          let extend = {};
          if (this.format.showExt && this.$sn.validate.json(this.format.showExt)) extend = JSON.parse(this.format.showExt);
          // 站内功能
          if (this.format.showType === '1') {
            if (extend.joinId) {
              const func = gatherConfig().find(result => extend.joinId === result.id);
              if (!this.$sn.validate.empty(func)) {
                url = func.url;
                item = func;
                params = func.params;
              }
            }
          }
          // 外部 H5
          else if (this.format.showType === '2') {
            url = extend.url;
          }
          // 外部小程序
          else if (this.format.showType === '3') {
            // TODO
          }
          // 直接进行后续跳转
          this.sendBack(true);
          this.navigateUrl(url, item, params);
        }
        else {
          this.exhibition = verify;
          if (['1', '2'].includes(this.format.buttonType)) {
            if (this.format.buttonType === '1') {
              if (this.format.buttonExt && this.$sn.validate.json(this.format.buttonExt) && JSON.parse(this.format.buttonExt).buttonSecond) {
                this.rotation = parseInt(JSON.parse(this.format.buttonExt).buttonSecond);
              }
            }
            else this.rotation = -1;
            if (this.rotation > 0) {
              this.rotationInterval = setInterval(() => {
                if (this.rotation > 0) this.rotation--;
              }, 1 * 1000);
            }
          }
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.rotation === -1) {
                this.handleScroll({
                  target: document.querySelector('.tip-info')
                });
              }
            }, 1 * 1000);
          });
        }
      }
      else this.sendBack(false);
    },
    handleInformation() {
      this.format = {};
      this.htmlCaption = [];
      return new Promise(resolve => {
        if (this.mode === '0') {
          resolve(!this.$sn.validate.empty(this.secretary) && !this.$sn.validate.empty(this.$sn.format.html(this.secretary)));
        }
        else if (this.mode === '1') {
          if (this.$sn.validate.empty(this.secretary)) {
            resolve(false);
            return false;
          }
          this.$sn.utils.ordinaryRequest({
            url: this.$sn.format.caption(Swagger.getTipCaptionInfo, [this.$sn.utils.getHospitalId(), this.secretary])
          }).then(result => {
            if (result && result.code === 0 && result.data) {
              this.format = result.data;
              resolve(true);
            }
            else resolve(false);
          });
        }
        else if (this.mode === '2') {
          if (this.$sn.validate.empty(this.url)) {
            resolve(false);
            return false;
          }
          this.$sn.utils.ordinaryRequest({
            domain: this.domain,
            url: this.url + '?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
          }).then(result => {
            if (result && this.$sn.vaidate.array(result) && result.length > 0) {
              this.htmlCaption = result;
              resolve(true);
            }
            else resolve(false);
          });
        }
        else resolve(false);
      });
    },
    handleScroll(e) {
      if (this.rotation === -1) {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        if ((scrollHeight - (scrollTop + clientHeight)) / clientHeight <= 0.05) this.rotation = 0;
      }
    },
    sendBack(type) {
      if ((type && this.rotation === 0) || !type) {
        this.$emit('sendBack', type);
      }
    },
    navigateUrl(url, item, params = {}, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {}
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  },
  beforeDestroy() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval);
    }
  }
};
</script>
<style lang="scss">
  .tip-caption {
    z-index: 999;

    .popup {
      width: 700px;
    }

    .region {
      width: 100%;
      height: 80vh;
      background-color: $white;
      border-radius: 8px;
      padding: 20px 20px 0;

      .tip-info {
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;

        .tip-blank {
          overflow: hidden;
          width: 100%;
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }

          img {
            width: var(--width);
            height: var(--height);
          }

          .tip-topic {
            @include fs(16);

            display: block;
            overflow: hidden;
            width: 100%;
            font-weight: bold;
            text-align: center;
            line-height: 40px;
          }

          .tip-line {
            @include fs(14);

            display: block;
            overflow: hidden;
            width: 100%;
            text-indent: 2em;
            line-height: 40px;
          }

          .tip-image {
            overflow: hidden;
          }

          .tip-polymerize {
            overflow: hidden;
            margin-right: 20px;

            &:last-child {
              margin-right: 0;
            }
          }

          .tip-horizontal {
            overflow-x: auto;
            overflow-y: hidden;
          }
        }
      }

      .tip-bottom {
        overflow: hidden;
        width: 100%;
        padding: 30px 0;

        .tip-interaction {
          @include fs(14);

          height: 40px;
          background-color: $main;
          color: $white;
          border-radius: 20px;
          padding: 0 20px;
        }
      }
    }
  }
</style>
